import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { combineEpics, createEpicMiddleware } from "redux-observable";
import { lastActionMiddleware } from "../last-action/last-action.reducers";
import { endAction, startAction } from "../loader/loader.actions";
import { getEffect, getStoreConfig } from "../tools/store.tools";
import { effectsConfig } from "./store.effects";
import { storeConfigs } from "./store.reducers";
const effectsMiddleware = createEpicMiddleware();
/* TODO
  Add success/fail fnc to action type
  Add notifier slice with toast service
*/
export const globalStore = configureStore({
    reducer: combineReducers(getStoreConfig(storeConfigs)),
    middleware: (gDM) => gDM({
        serializableCheck: false,
    })
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .concat(effectsMiddleware)
        .concat(lastActionMiddleware),
    devTools: process.env.NODE_ENV === "development",
});
const effects = effectsConfig.map(({ action, operatorFn }) => getEffect(action, operatorFn, (id) => globalStore.dispatch(startAction({ id })), (id) => globalStore.dispatch(endAction({ id }))));
const rootEffects = combineEpics(...effects);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
effectsMiddleware.run(rootEffects);
